import { BreadCrumbs, Container, Segment } from '@sloyd/ui';
import { useParams } from 'react-router-dom';
import { stages } from './ContentTextTo3d.data';
import { stageToComponent } from './ContentTextTo3d.parts';
import { Content, Top, Wrapper } from './ContentTextTo3d.style';

export type ContentTextTo3dProps = {
  isEmployee: boolean;
  lastPrompt: string;
  tsStart: number;
  externalGlb: string;
  credits: number;
  target: string;
  callbacks: {
    onGenerate: (prompt: string) => void;
    onDownload: (externalGlb: string, source: string) => void;
    onChangeTarget: (value: string) => void;
  };
};

export function ContentTextTo3d(props: ContentTextTo3dProps) {
  const { callbacks, target, isEmployee } = props;
  const { stage = 'describe' } = useParams();

  function renderInner() {
    const Cmp = stageToComponent[stage];

    if (!Cmp) return null;
    return <Cmp {...props} />;
  }

  return (
    <Wrapper className='ContentTextTo3d-wrapper' data-testid='ContentTextTo3d-wrapper'>
      <Container size='xl' flex>
        <Top>
          <BreadCrumbs items={stages} separator='&rarr;' value={stage} stage={stage} />
          <Segment
            value={target}
            data={['Standard', 'Low Poly', '3D Print']}
            onChange={(value: string) => callbacks.onChangeTarget(value)}
            maxWidth={280}
          />
        </Top>
        <Content size='md'>{renderInner()}</Content>
      </Container>
    </Wrapper>
  );
}

export default ContentTextTo3d;
